import { makeFieldValueDbModule } from '../makeFieldValueDbModule';
import { clear as additionalDocumentsServiceClear } from './additionalDocumentsService';
import { makeClearPublisher } from 'serviceWorker/broadcasts/publishers';
import { fieldValueContracts } from 'shared/domain/fieldValue/fieldValueContracts';
import { EditableFieldValuesEntityName } from 'shared/domain/fieldValue/fields';

export const {
  clear,
  quantity,
  get,
  getOne,
  addBatch,
  updateBatch,
  removeBatch,
} = makeFieldValueDbModule({
  tableName: 'additionalDocuments',
  serviceTableName: 'additionalDocumentsService',
  serviceClearFunction: additionalDocumentsServiceClear,
  broadcastClearFunction: makeClearPublisher(fieldValueContracts[EditableFieldValuesEntityName.additionalDocuments]),
});
